// src/modules/shared/utils/state-updates.ts
import { produce, Draft } from "immer";

export const updateEntityInList = <T extends { id: string }>(
  list: T[],
  updated: T,
): T[] =>
  produce(list, (draft: Draft<T>[]) => {
    const index = draft.findIndex((item) => item.id === updated.id);
    if (index !== -1) draft[index] = updated as Draft<T>;
    else draft.push(updated as Draft<T>);
  });

export const removeEntityFromList = <T extends { id: string }>(
  list: T[],
  id: string,
): T[] => list.filter((item) => item.id !== id);

export const sortByOrderIndex = <T extends { order_index: number }>(
  items: T[],
): T[] => [...items].sort((a, b) => a.order_index - b.order_index);

export const reindexItems = <T extends { order_index: number }>(
  items: T[],
): T[] => items.map((item, index) => ({ ...item, order_index: index }));
